export default __webpack_public_path__ + "static/media/10.384771b0.png";